module.exports = __webpack_public_path__ + "static/img/14010213.08e8130b.png";